exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button[data-v-11833737] {\n  align-items: center;\n  display: flex;\n}\nbutton .icon[data-v-11833737] {\n  border-radius: 9999px;\n  height: 30px;\n  width: 30px;\n  aspect-ratio: 1/1;\n  background-color: #e9f1fb;\n  color: #085FCE;\n  display: flex;\n  align-items: center;\n  place-content: center;\n  font-weight: 500;\n}\nbutton.active .icon[data-v-11833737] {\n  background-color: #085FCE;\n  color: white;\n}\nsmall[data-v-11833737] {\n  font-size: 15px;\n  color: #085FCE;\n  font-weight: 500;\n}", ""]);

// exports
